import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {
  BALL,
  FILTER_KEYS,
  FUTURE_PRACTICE,
  LIVE_PRACTICE,
  LOAD_EVENTS_TIME_LIVE_PAGE,
  PAST_PRACTICE,
  VIEW_BY_PLAYER,
  VIEW_SPEED_ZONE,
  PAST_GAME,
  DEFAULT_WEEK_COMPARE_TO_DATA,
  MESSAGES
} from '../../../config/constants';
import { useInterval, useRouter } from '../../../helpers/customHooks';
import Table, { HeadsType, RowsType, RowType } from '../../Shared/CustomTable';
import { fixDecimals, getDataScope } from '../../../helpers';
import { FiltersTabBallMetrics } from './FiltersTabBallMetrics';
import Loader from '../../Shared/Loader';
import PracticesAccordion from './PracticesAccordion';
import PlayerBallMetricsModal from '../Modal';
import { TabBallMetricsPropsType } from './types';
import { useDataEventsDispatch, useDataEventsState, useFiltersDispatch, useFiltersState, useLoadingState } from '../../../store/hooks';
import { PlayersBallByZoneType, PlayersBallType, QuarterListType, SessionListType } from '../../../config/commonTypes';
import * as DateFns from 'date-fns';

import './TabBallMetrics.scss';
import { Collapse } from 'antd';
import BallMetricsMobile from './BallmetricsMobile';

import { Week } from 'store/types';
import { DateRangeSelectorDataType } from 'components/Shared/Filters';
const { Panel } = Collapse;
const TabBallMetrics = ({ hidden, hasUpdate, isInProgress }: TabBallMetricsPropsType) => {

  const {
    params,
    pathname,
    push,
    search,
    viewPracticeGamePageScope,
    history
  } = useRouter<{ params: { id: string, teamId: string, modal: string, playerId: string } }>();
  
  const { changeFilterData } = useFiltersDispatch();

  const { id, teamId /*only for games*/, modal, playerId } = params;
  const dataScope = getDataScope(params.teamId);
  const { dataEvent: data } = useDataEventsState();
  const current = useLoadingState(viewPracticeGamePageScope);
  const dataMeta = data.meta;
  const dataPlayers = data.meta.type !== PAST_GAME? data.data.players : data[dataScope].players;
  const dataPlayersBall = data.meta.type !== PAST_GAME? data.data.playersBall : data[dataScope].playersBall;
  const dataPlayersBallByZone = data.meta.type !== PAST_GAME? data.data.playersBallByZone : data[dataScope].playersBallByZone;
  const { [FILTER_KEYS.SPEED_ZONE_TYPE]: zoneTypes,
          [FILTER_KEYS.POSITIONS]: playerPosition,
        } = useFiltersState(viewPracticeGamePageScope, FILTER_KEYS.SPEED_ZONE_TYPE, FILTER_KEYS.POSITIONS);
  const {[FILTER_KEYS.DATE_RANGE]: dateRange} = useFiltersState('VIEW_PRACTICE_PERFORMANCE_PAGE:'+id, FILTER_KEYS.DATE_RANGE);
  const { getBallMetricsPastData, getBallMetricsLiveData } = useDataEventsDispatch();
  const isMobile = window.matchMedia("only screen and (max-width: 900px)").matches;
  const view = new URLSearchParams(search).get('view');
  const changeDateSelected = (newData: DateRangeSelectorDataType<Week>) => changeFilterData(newData, FILTER_KEYS.DATE_RANGE, viewPracticeGamePageScope)();
  const initialDate = data.meta.startTime;
  const currentDate =  DateFns.subDays(initialDate ? new Date(initialDate) : new Date(), 1);
  const currentDefaultFilter: DateRangeSelectorDataType<Week> = {
    selectedDates: [{ start: DateFns.subDays(currentDate, 6), end: currentDate }],
    default: 7,
    year: 'Select',
    week: DEFAULT_WEEK_COMPARE_TO_DATA,
    isUseInProgressComps: false,
    isUseSameIntensity: false,
    includeGamesInComparisonAvg: false,
    selectedIdPractices: [],
    compareTo: 'dates',
    threshold: 'Select'
  };
  let maxDistance = 0;
  if (dataPlayers) {
    dataPlayers.forEach((player:any) => {
      maxDistance = Math.max(maxDistance, (
        +fixDecimals(player.metrics.walkYds, 0) +
        +fixDecimals(player.metrics.jogYds, 0) +
        +fixDecimals(player.metrics.runYds, 0) +
        +fixDecimals(player.metrics.sprintYds, 0) +
        +fixDecimals(player.metrics.maxSprintYds, 0)
      ));
    });
  }
  const prePath = pathname.split('/').splice(0, 6).join('/');

  const getData = useCallback((forceCall) => {
    if (data.meta.type === LIVE_PRACTICE) {
      getBallMetricsLiveData(data.data.playersBall.length === 0 || forceCall, isMobile)();
    }else if (data.meta.type === PAST_PRACTICE && (data.data.playersBall.length === 0 || forceCall)) {
      if(isMobile){
        getBallMetricsPastData(undefined, isMobile)();
      }else{
        getBallMetricsPastData()();
    }
    }else{
      if(!isMobile)getBallMetricsPastData(teamId)();
    }
  }, [dataPlayers, data.meta.type]); // teamId fot Games

  useEffect(() => {
    if(dateRange){
      changeDateSelected(dateRange as DateRangeSelectorDataType<Week>);
    }else{
      changeDateSelected(currentDefaultFilter as DateRangeSelectorDataType<Week>);
    }
    getData(true);
  }, [id, dataMeta.type, dataScope, data.meta.type === LIVE_PRACTICE && hasUpdate]);

  // live calls
  useInterval(() => getData(false),
    !hidden && dataMeta.type === LIVE_PRACTICE ? LOAD_EVENTS_TIME_LIVE_PAGE : null);

  const rowsPlayers: RowsType<string, number> = [];
  let positionFilter: any;
  if(playerPosition && playerPosition.length > 0){
    positionFilter = playerPosition.map(obj => obj.value);
  }
  const players = playerPosition && playerPosition.length > 0? dataPlayersBall.filter((player: PlayersBallType) => positionFilter.includes(player.position) ) 
  : dataPlayersBall;
  if (dataPlayersBall) {
    players.forEach((player: PlayersBallType) => {
      if (player.sessionList) {
        player.sessionList.forEach((session: SessionListType[0]) => {
          if (session.ballFlightModelList) {
            session.ballFlightModelList.forEach((ball, index) => {
              if (ball) {
                rowsPlayers.push({
                  columns: [
                    { class: 'flag', isPinFlagCell: true },
                    {
                      style: { fontWeight: 'bold', textAlign: 'left' },
                      content: player.playerName,
                      print: (content: string) => (
                        <Link to={{
                          pathname: prePath + '/modal/' + player.namespaceId,
                          search: view ? ('?view=' + view) : ''
                        }}>
                          <div
                            style={{
                              width: '131px',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden'
                            }}
                          >
                            {content}
                          </div>
                        </Link>
                      ),
                      order: (contentA: string, contentB: string) => {
                        if (contentA.split(' ').length < 2) {
                          return contentA.localeCompare(contentB);
                        }
                        const lastNameA = contentA.split(' ')[1];
                        const lastNameB = contentB.split(' ')[1];
                        return lastNameA.localeCompare(lastNameB);
                      },
                    },
                    { content: player.jerseyNumber, print: (content: string) => ('#' + content) },
                    { class: 't-ll', content: player.position },
                    { content: ball.flightType },
                    { content: fixDecimals(ball.initialAirSpeedMPH, 1) },
                    { content: fixDecimals(ball.initialRotationRPM, 0) },
                    { content: fixDecimals(ball.flightDurationSec, 2) },
                    { content: fixDecimals(ball.peakHeightFt, 1) },
                    { content: fixDecimals(ball.groundDistanceYds, 1) },
                    {
                      content: ball.startTimeMS,
                      print: (content: number) => <>{moment.tz(content, moment.tz.guess()).format('hh:mm:ss')}</>
                    },
                    {}
                  ],
                  id: player.namespaceId + session.sessionName + session.sessionNumber + index
                });
              }
            });
          }
        });
      }else{
        if(player.quarterList){
          player.quarterList.forEach((quarter: QuarterListType[0]) => {
            if (quarter.ballFlightModelList) {
              quarter.ballFlightModelList.forEach((ball, index) => {
                if (ball) {
                  rowsPlayers.push({
                    columns: [
                      { class: 'flag', isPinFlagCell: true },
                      {
                        style: { fontWeight: 'bold', textAlign: 'left' },
                        content: player.playerName,
                        print: (content: string) => (
                          <Link to={{
                            pathname: prePath + '/modal/' + player.namespaceId,
                            search: view ? ('?view=' + view) : ''
                          }}>
                            <div
                              style={{
                                width: '131px',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden'
                              }}
                            >
                              {content}
                            </div>
                          </Link>
                        ),
                        order: (contentA: string, contentB: string) => {
                          if (contentA.split(' ').length < 2) {
                            return contentA.localeCompare(contentB);
                          }
                          const lastNameA = contentA.split(' ')[1];
                          const lastNameB = contentB.split(' ')[1];
                          return lastNameA.localeCompare(lastNameB);
                        },
                      },
                      { content: player.jerseyNumber, print: (content: string) => ('#' + content) },
                      { class: 't-ll', content: player.position },
                      { content: ball.flightType },
                      { content: fixDecimals(ball.initialAirSpeedMPH, 1) },
                      { content: fixDecimals(ball.initialRotationRPM, 0) },
                      { content: fixDecimals(ball.flightDurationSec, 2) },
                      { content: fixDecimals(ball.peakHeightFt, 1) },
                      { content: fixDecimals(ball.groundDistanceYds, 1) },
                      {
                        content: quarter.quarterName === 'Pre-Game'? ball.startTimeMS : ball.playId,
                        print: (content: number) => <>{quarter.quarterName === 'Pre-Game'? moment.tz(content, moment.tz.guess()).format('hh:mm:ss') : content}</>
                      },
                      {}
                    ],
                    id: player.namespaceId + quarter.quarterName + quarter.quarter + index
                  });
                }
              });
            }
          });
        }
      }
    });
  }
  let headers: HeadsType<string>;
  if (view === VIEW_BY_PLAYER) {
    headers = [
      { content: 'PLAYER', class: 't-ll', isOrderly: true, style: { width: '323px' } },
      { content: 'FLIGHT TYPE', isOrderly: true, style: { width: '85px', textAlign: 'right' } },
      { content: 'INITIAL AIR SPEED (MPH)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'INITIAL ROTATION (RPM)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'FLIGHT DURATION(S)', isOrderly: true, style: { width: '90px', textAlign: 'right' } },
      { content: 'PEAK HEIGHT (FT)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'GROUND DISTANCE (YDS)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      dataMeta.type !== PAST_GAME?
      { content: 'FLIGHT TIME', isOrderly: true, style: { width: '110px', textAlign: 'right' } }
      :
      {content: 'PLAY ID/FLIGHT TIME', isOrderly: true, style: { width: '110px', textAlign: 'right' }},
      { style: { width: '364px' } }
    ];
  } else {
    headers = [
      { isPinFlagCell: true, isSelectable: true, style: { width: '33px' }, class: 'flag' },
      { content: 'PLAYER', isOrderly: true, style: { width: '160px' } },
      { content: 'NO.', isOrderly: true, style: { width: '50px', textAlign: 'right' } },
      { content: 'POS.', class: 't-ll', isOrderly: true, style: { width: '80px', textAlign: 'right' } },
      { content: 'FLIGHT TYPE', isOrderly: true, style: { width: '85px', textAlign: 'right' } },
      { content: 'INITIAL AIR SPEED (MPH)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'INITIAL ROTATION (RPM)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'FLIGHT DURATION(S)', isOrderly: true, style: { width: '90px', textAlign: 'right' } },
      { content: 'PEAK HEIGHT (FT)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      { content: 'GROUND DISTANCE (YDS)', isOrderly: true, style: { width: '75px', textAlign: 'right' } },
      dataMeta.type !== PAST_GAME?
      { content: 'FLIGHT TIME', isOrderly: true, style: { width: '110px', textAlign: 'right' } }
      :
      { content: 'PLAY ID/FLIGHT TIME', isOrderly: true, style: { width: '110px', textAlign: 'right' } },
      { style: { width: '364px' } }
    ];
  }
  const titleHeaders: HeadsType<string, JSX.Element> = [
    { class: 't-ll', style: { width: '323px' }, content: <div>PLAYER</div> },
    { style: { width: '949px' }, content: <div>BALL PERFORMANCE METRICS</div> }
  ];

  const titleHeadersSpeedZone = [
    { class: 't-ll', style: { width: '270px' }, content: <div>Player</div> },
    { style: { width: '1002px' }, content: <div>Ball performance metrics</div> }
  ];
  const headersSpeedZone: HeadsType<string> = [
    { content: 'PLAYER', isOrderly: true, style: { width: '170px', textAlign: 'left' } },
    { content: 'NO.', isOrderly: true, style: { width: '50px' } },
    { content: 'POS.', isOrderly: true, style: { width: '50px' }, class: 't-ll' },
    { content: 'Flight type', isOrderly: true, style: { width: '80px' } },
    { content: 'Initial Air speed (MPH)', isOrderly: true, style: { width: '75px' } },
    { content: 'initial rotation (RPM)', isOrderly: true, style: { width: '75px' } },
    { content: 'flight duration (s)', isOrderly: true, style: { width: '75px' } },
    { content: 'peak height (ft)', isOrderly: true, style: { width: '75px' } },
    { content: 'ground distance (YDS)', isOrderly: true, style: { width: '85px' } },
    { content: 'Flight time', isOrderly: true, style: { width: '80px' } },
    { style: { width: '457px' } }
  ];
  const rowsSpeedZone: { rows: RowsType<string>, zone: PlayersBallByZoneType }[] = [];
  if (dataPlayersBallByZone) {
    dataPlayersBallByZone.forEach((zone: any) => {
      if (!zoneTypes || zoneTypes.length === 0 || (Array.isArray(zoneTypes) && zoneTypes.some(((value: { value: string }) => value.value === zone.speedZone)))) {
        const rowsBySpeedZone: RowsType<string> = [];
        const players = playerPosition && playerPosition.length > 0? zone.ballFlightModelList.filter((player: PlayersBallType) => positionFilter.includes(player.position) ) 
        : zone.ballFlightModelList;
        players.forEach((player: any, index:any) => {
          rowsBySpeedZone.push({
            columns: [
              {
                style: {
                  fontWeight: 'bold',
                  textAlign: 'left'
                },
                content: player.playerName,
                print: (content) => (
                  <Link to={{ pathname: prePath + '/modal/' + player.namespaceId, search }}>
                    <div
                      style={{
                        width: '126px',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden'
                      }}
                    >
                      {content}
                    </div>
                  </Link>
                ),
                order: (contentA, contentB) => {
                  if (contentA.split(' ').length < 2) {
                    return contentA.localeCompare(contentB);
                  }
                  const lastNameA = contentA.split(' ')[1];
                  const lastNameB = contentB.split(' ')[1];
                  return lastNameA.localeCompare(lastNameB);
                },
              },
              { content: player.jerseyNumber, print: (content => '#' + content) },
              { class: 't-ll', content: player.position },
              { content: player.flightType },
              { content: fixDecimals(player.initialAirSpeedMPH, 1) },
              { content: fixDecimals(player.initialRotationRPM, 0) },
              { content: fixDecimals(player.flightDurationSec, 2) },
              { content: fixDecimals(player.peakHeightFt, 1) },
              { content: player.groundDistanceYds >=0 ? fixDecimals(player.groundDistanceYds, 1):'-' },
              {
                content: player.startTimeMS,
                print: content => <>{moment.tz(content, moment.tz.guess()).format('hh:mm:ss')}</>
              },
              {}
            ],
            id: player.playerName + zone.speedZone + index
          });
        });
        rowsSpeedZone.push({ rows: rowsBySpeedZone, zone: zone });
      }
    });
  }
  const areAllRowsSpeedEmpty = rowsSpeedZone.every(item =>
    item.rows.every(row => Object.keys(row).length === 0)
  );
  return (
    <>
      {modal && playerId && (
        <PlayerBallMetricsModal
          initialTab={BALL}
          show={true}
          onHide={() => (push({ pathname: prePath + '/page', search, state: history.location.state }))}
          hidden={hidden}
          hasUpdate={hasUpdate}
        />
      )}
      <FiltersTabBallMetrics
        loadData={() => getData(true)}
        teamId={teamId ? teamId : dataMeta.homeTeam.teamId}
        isInProgress={isInProgress}
      />
      {view === VIEW_BY_PLAYER ? (
        dataMeta.type === FUTURE_PRACTICE ? (
          <Loader
            style={{ height: 'calc(100vh - 108px)' }}
            forceMessage="Practice hasn't started. Start the practice to see live performance data."
          />
        ) : (
          <div className={'practice-body adjust-height-practices-ball-metrics mobile-table mobile-table-width'}>
            <Loader forceScope={viewPracticeGamePageScope} forceLoader={current.count > 0} forceMessage={players.length === 0 ? MESSAGES.EMPTY_BALL_FLIGHTS_LIVE :''}>
              <Table<HeadsType<string, JSX.Element>, RowType<string>>
                classTable="ball-metrics-group-by-player"
                headers={headers}
                titleHeaders={titleHeaders}
                rows={[]}
                // dataMeta.type === PAST_GAME? VIEW_BY_PLAYER ? 8 : 11 : VIEW_BY_PLAYER ? 
                default={{ orderColumn: -8 }}
                forceScope={'BY_PLAYER'+viewPracticeGamePageScope}
                isCombinedTable={true}
              />
              {players && players.length > 0 && (
                <div className="t-body t-body-scroll" style={{ overflow: 'auto' }}>
                  <PracticesAccordion players={players} forceScope={'BY_PLAYER'+viewPracticeGamePageScope}/>
                </div>
              )}
              <div className="ball-metrics-mobile">
               <BallMetricsMobile rows={dataPlayersBall}/>
              </div>
            </Loader>
          </div>
        )
      ) : view === VIEW_SPEED_ZONE ? (
        <div className="practice-body practice-body-width adjust-height-practices-ball-metrics speed-zone ">
          <Loader forceScope={viewPracticeGamePageScope} forceLoader={current.count > 0} forceMessage={areAllRowsSpeedEmpty? MESSAGES.EMPTY_BALL_FLIGHTS_LIVE :''} >
            <Table<HeadsType<string, JSX.Element>, RowType<string>>
              classTable="ball-metrics-speed-zone-only-header"
              titleHeaders={titleHeadersSpeedZone}
              headers={headersSpeedZone}
              rows={[]}
              isPinnedStyle
              forceScope={'SPEED'+viewPracticeGamePageScope} 
              default={{orderColumn: -10}}
              isCombinedTable={true}
            />
            <div className="speed-zone-data">
              {rowsSpeedZone.sort((a, b) => -a.zone.speedZone.localeCompare(b.zone.speedZone)).map(tableZone => {
                return (
                  tableZone.rows.length !== 0 &&(
                    <>
                    <div className="caption-sz">
                      <label>{tableZone.zone.speedZone}</label>
                    </div>
                    <div>
                      <Table<HeadsType<string>, RowType<string>>
                        classTable="ball-metrics-speed-zones"
                        headers={headersSpeedZone}
                        rows={tableZone.rows}
                        withoutScroll
                        forceScope={'SPEED'+viewPracticeGamePageScope}
                        default={{orderColumn: -10}}
                      />
                    </div>
                      <div className="foot-sz">
                      <div style={{ width: '270px' }}><span>zone summary</span></div>
                      <div style={{ width: '80px', textAlign: 'left' }}><p>Total</p>
                        <label>{fixDecimals(tableZone.zone.total, 0)}</label></div>
                      <div style={{ width: '75px', textAlign: 'left' }}><p>Average</p>
                        <label>{fixDecimals(tableZone.zone.avgInitAirSpeedInMph, 1)}</label>
                      </div>
                      <div style={{ width: '75px', textAlign: 'left' }}><p>Average</p>
                        <label>{fixDecimals(tableZone.zone.avgInitRotation, 1)}</label>
                      </div>
                      <div style={{ width: '75px', textAlign: 'left' }}><p>Average</p>
                        <label>{fixDecimals(tableZone.zone.avgFlightDurInSec, 2)}</label>
                      </div>
                      <div style={{ width: '75px', textAlign: 'left' }}><p>Average</p>
                        <label>{fixDecimals(tableZone.zone.avgPeakHeightInFeet, 1)}</label>
                      </div>
                      <div style={{ width: '85px', textAlign: 'left' }}><p>Average</p>
                        <label>{fixDecimals(tableZone.zone.avgGroundDistInYards, 1)}</label>
                      </div>
                    </div>
                     </>
                    )   
                );
              })}
            </div>
          </Loader>
        </div>
      ) : (
        <div className={'practice-body practice-body-scroll adjust-height-practices-ball-metrics'}>
          <Loader forceScope={viewPracticeGamePageScope} forceLoader={current.count > 0} forceMessage={rowsPlayers.length === 0 ? MESSAGES.EMPTY_BALL_FLIGHTS_LIVE :''}>
            <Table
              forceScope={'VIEW_'+teamId}
              classTable="ball-metrics-group-players"
              headers={headers}
              titleHeaders={titleHeaders}
              rows={rowsPlayers}
              isPinnedStyle
              default={{ orderColumn: -11}}
            />
          </Loader>
        </div>
      )}
    </>
  );
};

export default TabBallMetrics;
